import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => ({
  position: state.selectedPosition || state.positions[0],
  wantsToRun:
    state.selectedPosition &&
    state.lead &&
    state.lead.position_id === state.selectedPosition.position_id,
  enableRunningFor: state.appConfig.enableRunningFor,
})

export default connect(mapStateToProps)



// WEBPACK FOOTER //
// ./src/components/Position/RunModal/runModalContainer.js